import { IPlayersGroupGames } from "@grassrootly/api/entities";
import withErrorCheck from "../CheckError";
import server from "../Server";

export interface PlayersNextGamesParams {
  date_from: string;
  pid: number;
}

export const GetPlayersNextGames = async ({
  date_from,
  pid,
}: PlayersNextGamesParams): Promise<IPlayersGroupGames[]> => {
  const nextGames = withErrorCheck(
    // @ts-ignore
    await server.rpc("players_next_games", { date_from, pid })
  );

  if (!nextGames) return [];

  return nextGames;
};